import React from 'react';
import PropTypes from 'prop-types';

import InfoBox from '../../../../UI/InfoBox'

export default class MetaListItem extends React.Component {
    static propTypes = {
        title: PropTypes.string,
        helpText: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.array,
            PropTypes.node
        ]),
        helpTextActionLabel: PropTypes.string,
        helpTextActionUrl: PropTypes.string,
        contents: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.array
        ]),
        modifierClass: PropTypes.array,
        compactMode: PropTypes.bool
    }

    static defaultProps = {
        title: '',
        helpText: '',
        contents: [],
        modifierClass: [],
        compactMode: false
    };

    render() {
        const helpText = this.props.helpText;
        const contentRows = this.props.contents.length ? this.props.contents : [this.props.contents];
        const titleClasses = ['meta-list__list__title'];
        const content = contentRows.map((content, index) => {
            const contentClasses = ['meta-list__list__content'];
            if (this.props.compactMode) {
                contentClasses.push('meta-list__list__content--compact');
            }

            return (
                <dd key={index + '_'} className={contentClasses.join(' ')}>
                    {content}
                </dd>
            );
        });
        let helpTextElement;

        if (helpText) {
            helpTextElement = (
                <InfoBox fontSize={16}>
                    {helpText}
                </InfoBox>
            );
        }

        if (this.props.compactMode) {
            titleClasses.push('meta-list__list__title--compact');
        }

        return (
            <React.Fragment>
                {this.props.title && (
                    <dt className={titleClasses.join(' ')}><h5 className="meta-list__list__title__heading">{this.props.title} {helpTextElement}</h5></dt>
                )}
                {content}
            </React.Fragment>
        );
    }
};

